import React, { useMemo } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Polygon } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Ensure Leaflet's default marker icons load correctly in CRA/webpack builds
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const defaultMarkerIcon = new L.Icon({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const ServiceAreas = () => {
  const cities = useMemo(() => {
    const north = { name: 'Schroon Lake', lat: 43.7156, lng: -73.7053 };
    const east = { name: 'Granville, NY', lat: 43.4131, lng: -73.2569 };
    const south = { name: 'Clifton Park', lat: 42.8926, lng: -73.8205 };
    const galway = { name: 'Galway', lat: 43.0268, lng: -73.8521 };
    const schenectady = { name: 'Schenectady', lat: 42.8142, lng: -73.9396 };

    const west = (galway.lng < schenectady.lng) ? galway : schenectady;
    return [north, east, south, west];
  }, []);

  const polygonLatLngs = useMemo(() => cities.map((c) => [c.lat, c.lng]), [cities]);
  const bounds = useMemo(() => polygonLatLngs, [polygonLatLngs]);

  return (
    <section className="services">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Service Areas</h2>
          <p className="section-description">Approximate service area in Upstate NY.</p>
        </div>

        <div style={{ height: 520, borderRadius: 12, overflow: 'hidden', border: '1px solid var(--border)' }}>
          <MapContainer bounds={bounds} boundsOptions={{ padding: [20, 8] }} style={{ height: '100%', width: '100%' }}>
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            {cities.map((c, i) => (
              <Marker key={i} position={[c.lat, c.lng]} icon={defaultMarkerIcon}>
                <Popup>{c.name}</Popup>
              </Marker>
            ))}

            <Polygon positions={polygonLatLngs} pathOptions={{ color: 'var(--accent)' }} />
          </MapContainer>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
